import { useEffect, useState } from 'react';

export interface Expansion {
    id: string | null;
    isExpanded: (id: string) => boolean;
    toggle: (id: string) => void;
    collapse: () => void;
}

export interface UseExpansionArgs {
    ids: string[];
    onExpand?: () => void;
}
export function useExpansion(args: UseExpansionArgs): Expansion {
    const { ids, onExpand } = args;
    const [id, setId] = useState<string | null>(null);

    useEffect(() => {
        if (id !== null && !ids.includes(id)) setId(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps -- react only on `ids` identity, not on `id`
    }, [ids]);

    const isExpanded = (candidate: string): boolean => candidate === id;

    const toggle = (candidate: string): void => {
        if (candidate === id) {
            setId(null);
            return;
        }
        setId(candidate);
        onExpand?.();
    };

    const collapse = (): void => {
        setId(null);
    };

    return { id, isExpanded, toggle, collapse };
}
